import React, { Component } from 'react';
import PropTypes from 'prop-types';
import deepEqual from 'deep-equal';
import _ from 'underscore';
import { unescapeHTML } from 'underscore.string';
import { Col, Row, FormControl, ControlLabel } from 'react-bootstrap';

import LocationAutosuggest from 'components/site/location-autosuggest';
import SearchBox from 'components/site/SearchBox';
import { withTranslation, Trans } from 'react-i18next';
import CargomaticInput from 'components/v2/input';

function getLocation(item) {
  if (item && item.name) {
    return item.name;
  }
  return 'Unknown Location Name';
}

const createOnRemove = (item, onClick) => (e) => {
  e.stopPropagation();
  onClick(item);
};

const createRenderItem = (onClick) => (item) =>
  (
    <a key={item._id} className="list-group-item" style={{ cursor: 'pointer' }}>
      <div className="flex justify-between">
        <p style={{ cursor: 'pointer' }} className="list-group-item-heading">
          <span className="searchName">{getLocation(item)}</span>
        </p>
        <button
          className="button px-4 text-xl"
          onClick={createOnRemove(item, onClick)}
        >
          <i className="fa fa-close text-xl text-grey hover:text-grey-darker" />
        </button>
      </div>
    </a>
  );

class Location extends Component {
  constructor(props) {
    super(props);
    this.state = { items: props.locations };
    const location = props.location || {};
    const name = location.name || '';
    if (name) {
      this.search(name);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!deepEqual(this.props.locations, nextProps.locations)) {
      const items = nextProps.locations;
      this.setState({ items });
    }

    if (!deepEqual(this.props.location.name, nextProps.location.name)) {
      this.search(nextProps.location.name);
    }
  }

  clear() {
    this.setState({ items: [] });
  }

  search = (nGram) => {
    const searchTerm = (nGram || '').toLowerCase();
    const filteredItems = (this.props.locations || []).filter((c) =>
      (c.name || '').toLowerCase().includes(searchTerm),
    );

    const items = _.sortBy(filteredItems, (l) => (l.name || '').toLowerCase());
    this.setState({ items });
  };

  handleRemoveLocation = (locationId) => {
    this.props.onRemoveLocation(locationId);
  };

  handleAutocompleteNameChange = (item) => this.props.onChange('name', item);
  handleNameChange = (value) => this.props.onChange('name', value);
  handleNameSelect = (value, item) => this.props.onNameSelect(item);
  handleAddressSelect = (item) => {
    this.setState(
      {
        suggestions: [{ item }],
      },
      () => {
        this.props.onAddressSelect({ location: item, label: item.address });
      },
    );
  };
  handleSuiteOrAptChange = (e) =>
    this.props.onChange('suite_or_apt', e.target.value);

  render() {
    const { location, locations, label, t } = this.props;
    const hasLocations = locations && locations.length > 0;

    return (
      <div className="grid grid-cols-6 gap-4">
        <div
          id={`${label ? label + '-' : ''}location-details`}
          className="col-span-full"
        >
          <div className="flex items-center space-x-1">
            <Trans
              i18nKey="NAME_REQUIRED"
              components={[
                <label className="mb-1 form-label" />,
                <small className="text-muted" />,
              ]}
            />
          </div>
          {hasLocations && (
            <div className="mb-4">
              <SearchBox
                id={`${label ? label + '-' : ''}name`}
                appendItems
                items={this.state.items}
                clear={() => this.clear()}
                search={(nGram) => this.search(nGram)}
                placeholder={t('NAME', { count: 1 })}
                onChange={this.handleAutocompleteNameChange}
                onSelect={this.handleNameSelect}
                value={unescapeHTML(location.name)}
                getItemValue={getLocation}
                renderItem={createRenderItem(this.handleRemoveLocation)}
              />
            </div>
          )}
          {!hasLocations && (
            <div className="mb-4">
              <CargomaticInput
                id={`${label ? label + '-' : ''}name`}
                placeholder={t('NAME', { count: 1 })}
                value={unescapeHTML(location.name)}
                type="text"
                onChange={this.handleNameChange}
                hideLabel
              />
            </div>
          )}
        </div>

        <div className="col-span-4" id={`${label ? label + '-' : ''}address`}>
          <Trans
            i18nKey="ADDRESS_REQUIRED"
            components={[
              <ControlLabel className="mb-2" />,
              <small className="text-muted" />,
            ]}
          />
          <div className="mb-4">
            <LocationAutosuggest
              className="mb-4"
              key={location.address.label}
              id={`${label ? label + '-' : ''}autosuggest-address`}
              name={unescapeHTML(location.name)}
              address={location.address.label}
              value={location.address.label}
              suggestions={[
                {
                  name: unescapeHTML(location.name),
                  address: location.address.label,
                },
              ]}
              callbackSelectedItem={this.handleAddressSelect}
            />
          </div>
        </div>

        <div className="col-span-2">
          <label className="mb-1 form-label">{t('SUITE_APT')}</label>
          <div className="mb-4">
            <input
              type="text"
              className="form-field"
              placeholder="1A"
              onChange={this.handleSuiteOrAptChange}
              value={location.suite_or_apt}
            />
          </div>
        </div>
      </div>
    );
  }
}

Location.propTypes = {
  location: PropTypes.object.isRequired,
  locations: PropTypes.array,
  onAddressSelect: PropTypes.func.isRequired,
  onNameSelect: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onRemoveLocation: PropTypes.func.isRequired,
};

Location.defaultProps = {
  locations: [],
  onNameSelect: () => {},
};

export default withTranslation()(Location);
